import CaseTypes from "Containers/MSF/Cases/types"

export const downloadDocumentAction = payload => ({
  type: CaseTypes.DOWNLOAD_DOCUMENT,
  payload,
})

export const createAffaireAction = payload => ({
  type: CaseTypes.POST_AFFAIRE,
  payload,
})

export const createAffaireSuccess = payload => ({
  type: CaseTypes.POST_AFFAIRE_SUCCESS,
  payload,
})

export const deleteDocumentAffaireAction = payload => ({
  type: CaseTypes.DELETE_DOCUMENT_AFFAIRE,
  payload,
})

export const updateAffaireAction = payload => ({
  type: CaseTypes.PATCH_AFFAIRE,
  payload,
})

export const updateAffaireSuccess = payload => ({
  type: CaseTypes.PATCH_AFFAIRE_SUCCESS,
  payload,
})

export const addAndSendFinalContractForSignatureAction = payload => ({
  type: CaseTypes.ADD_AND_SEND_CONTRACT_FOR_SIGNATURE,
  payload,
})

export const getAffairesAction = (payload) => ({
  type: CaseTypes.GET_AFFAIRES,
  payload,
})

export const getAffairesSuccess = payload => ({
  type: CaseTypes.GET_AFFAIRES_SUCCESS,
  payload,
})

export const getAffaireByIdAction = payload => ({
  type: CaseTypes.GET_AFFAIRE_BY_ID,
  payload,
})

export const getAffaireByIdSuccess = payload => ({
  type: CaseTypes.GET_AFFAIRE_BY_ID_SUCCESS,
  payload,
})

export const updateDataAffaireAction = payload => ({
  type: CaseTypes.PATCH_DATA_AFFAIRE,
  payload,
})

export const updateDataAffaireSuccess = payload => ({
  type: CaseTypes.PATCH_DATA_AFFAIRE_SUCCESS,
  payload,
})

export const getNumberOfAffairesCreatedThisYearAction = () => ({
  type: CaseTypes.GET_NUMBER_OF_AFFAIRES_CREATED_THIS_YEAR,
})

export const getNumberOfAffairesCreatedThisYearSuccess = payload => ({
  type: CaseTypes.GET_NUMBER_OF_AFFAIRES_CREATED_THIS_YEAR_SUCCESS,
  payload,
})

export const getLineNameByCodeAction = payload => ({
  type: CaseTypes.GET_LINE_NAME_BY_CODE,
  payload,
})

export const getLineNameByCodeSuccess = payload => ({
  type: CaseTypes.GET_LINE_NAME_BY_CODE_SUCCESS,
  payload,
})

export const clearLineNameAction = () => ({
  type: CaseTypes.CLEAR_LINE_NAME,
})

export const exportDocumentsZipAction = payload => ({
  type: CaseTypes.EXPORT_DOCUMENTS_ZIP,
  payload,
})

export const exportExcelAction = payload => ({
  type: CaseTypes.EXPORT_EXCEL,
  payload,
})

export const getWorksPlanningAction = payload => ({
  type: CaseTypes.GET_WORKS_PLANNING,
  payload,
})

export const getWorksPlanningSuccess = payload => ({
  type: CaseTypes.GET_WORKS_PLANNING_SUCCESS,
  payload,
})

export const createWorksPlanningAction = payload => ({
  type: CaseTypes.POST_WORKS_PLANNING,
  payload,
})

export const updateWorksPlanningAction = payload => ({
  type: CaseTypes.PATCH_WORKS_PLANNING,
  payload,
})

export const deleteWorksPlanningAction = payload => ({
  type: CaseTypes.DELETE_WORKS_PLANNING,
  payload,
})

export const validateWorksPlanningAction = payload => ({
  type: CaseTypes.VALIDATE_WORKS_PLANNING,
  payload,
})

export const getCapacitesAction = payload => ({
  type: CaseTypes.GET_CAPACITES,
  payload,
})

export const getCapacitesSuccess = payload => ({
  type: CaseTypes.GET_CAPACITES_SUCCESS,
  payload,
})

export const createCapacitesAction = payload => ({
  type: CaseTypes.POST_CAPACITES,
  payload,
})

export const updateCapacitesAction = payload => ({
  type: CaseTypes.PATCH_CAPACITES,
  payload,
})

export const deleteCapacitesAction = payload => ({
  type: CaseTypes.DELETE_CAPACITES,
  payload,
})


export const getModelsAction = () => ({
  type: CaseTypes.GET_MODELS,
})

export const getModelsByTypeAction = payload => ({
  type: CaseTypes.GET_MODELS_BY_TYPE,
  payload,
})

export const getModelsSuccess = payload => ({
  type: CaseTypes.GET_MODELS_SUCCESS,
  payload,
})

export const createModelAction = payload => ({
  type: CaseTypes.POST_MODEL,
  payload,
})

export const createModelSuccess = payload => ({
  type: CaseTypes.POST_MODEL_SUCCESS,
  payload,
})

export const deleteModelAction = payload => ({
  type: CaseTypes.DELETE_MODEL,
  payload,
})

export const deleteModelSuccess = payload => ({
  type: CaseTypes.DELETE_MODEL_SUCCESS,
  payload,
})

export const sendEmailAction = payload => ({
  type: CaseTypes.MSF_SEND_EMAIL,
  payload,
})
